import { Injectable } from '@angular/core';
import { AES, enc } from 'crypto-js';
import { PlatformService } from '../services/platform.services';
export class StorageService {
/**
 * @param {?} platformService
 */
constructor(public platformService: PlatformService) {}
/**
 * @param {?} name
 * @param {?} data
 * @return {?}
 */
public set(name: string, data: any): void {
    if (this.platformService.isBrowser) {
      const /** @type {?} */ encryptedLoanData = AES.encrypt(JSON.stringify(data), name);

      localStorage.setItem(name, encryptedLoanData);
    }
  }
/**
 * @param {?} name
 * @return {?}
 */
public get(name: string): string {
    if (this.platformService.isBrowser) {
      const /** @type {?} */ decryptLnData = AES.decrypt(
        localStorage.getItem(name) || {}.toString(),
        name,
      );

      const /** @type {?} */ decryptedData = decryptLnData.toString(enc.Utf8);

      return decryptedData;
    }
  }
/**
 * @param {?} name
 * @return {?}
 */
public remove(name: string): void {
    if (this.platformService.isBrowser) {
      localStorage.removeItem(name);
    }
  }
/**
 * @param {?} name
 * @return {?}
 */
public valueExist(name: string): boolean {
    if (this.platformService.isBrowser) {
      if (localStorage.getItem(name)) {
        return true;
      } else {
        return false;
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: PlatformService, },
];
}

function StorageService_tsickle_Closure_declarations() {
/** @type {?} */
StorageService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
StorageService.ctorParameters;
/** @type {?} */
StorageService.prototype.platformService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
